import * as TYPES from './action-type';

export const setToken = data =>({
    type: TYPES.TOKEN,
    data,
})